import {
  base_colorContentBorder,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${spacing(4)};
  padding: ${spacing(3)} 0;
  border-bottom: 1px solid ${base_colorContentBorder};

  &:last-child {
    border-bottom: none;
  }

  .SettingsControlRow-text {
    min-width: 0;
  }

  .SettingsControlRow-title {
    font-family: ${font_family_weight_medium};
    ${font_md};
    color: ${text_colorTextPrimary};
  }

  .SettingsControlRow-description {
    margin-top: ${spacing(1)};
    max-width: 44ch;
    font-family: ${font_family_weight_regular};
    ${font_sm};
    color: ${text_colorTextSecondary};
  }

  .SettingsControlRow-control {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    gap: ${spacing(2)};
  }
`
